export { DeviceMobile as default } from './DeviceMobile';
